import { isConversationTurnStart } from '../../shared/conversationTurns';
import type { BackgroundTask } from '../../shared/backgroundTasks';
import type { CoworkMessage } from '../types/cowork';

/** 优先使用任务工具 ID 定位；没有对应工具时使用持久执行轮次，禁止按文本猜配。 */
export function backgroundTaskAnchor(task: BackgroundTask, messages: CoworkMessage[]): { turnId: string; messageId: string } | null {
  let turnId = '', fallback: { turnId: string; messageId: string } | null = null;
  for (const message of messages) {
    if (isConversationTurnStart(message)) {
      turnId = message.id;
      if (task.turnId && Array.isArray(message.metadata?.billingTurnIds) && message.metadata.billingTurnIds.includes(task.turnId)) fallback = { turnId, messageId: message.id };
    }
    if (turnId && task.toolUseId && message.type === 'tool_use' && message.metadata?.toolUseId === task.toolUseId) return { turnId, messageId: message.id };
  }
  return fallback;
}
